import { useContext } from 'react';

import { XYChartThresholdsContext } from '../context/XYChartThresholds.context.js';

export const useGetThresholds = () => {
  const context = useContext(XYChartThresholdsContext);

  if (context === undefined) {
    throw new Error(
      'useGetThresholds must be used within a XYChartThresholdsContext',
    );
  }

  return context;
};
